module.exports = __webpack_public_path__ + "img/icon_HT.5e302a69.jpg";